import type { Component } from 'vue'

export interface ModalOptions {
  // Vuetify v-dialog props
  width?: string | number
  maxWidth?: string | number
  fullscreen?: boolean
  persistent?: boolean
  scrollable?: boolean

  // Custom options
  closable?: boolean
  closeOnEsc?: boolean
  closeOnClickOutside?: boolean
  hideHeader?: boolean
  noPadding?: boolean
  subtitle?: string
  icon?: string

  // Props to pass to the component
  props?: Record<string, unknown>

  // Callbacks
  onClose?: (result?: unknown) => void
  onConfirm?: (result?: unknown) => void
}

export interface Modal {
  id: string
  title: string
  component: Component
  options: ModalOptions
  resolve: (result: ModalResult) => void
}

export interface ModalResult<T = unknown> {
  confirmed: boolean
  data?: T
}

export const MODAL_CLOSE_KEY = Symbol('modalClose')
export const MODAL_CONFIRM_KEY = Symbol('modalConfirm')
